import { sponsorAxiosInstance } from './base-service';

export const GetOktUserToken = async () => {
  const res = await sponsorAxiosInstance.get('v1/sponsor/login/Okta', {});
  return res;
};
